import { c } from '../../../utils/tailwind-merge';
import { RichText } from '../../molecules/RichText/RichText';
import { ReleaseDetailProps } from './ReleaseDetail.types';

export const ReleaseDetail = ({
  released,
  detail,
  className = '',
}: ReleaseDetailProps) => {
  return (
    <article className={className}>
      <h4 className={c('mb-4 mt-6 text-xs text-grey-600 md:mb-5 md:mt-0')}>
        {released}
      </h4>
      <RichText
        type="p"
        html={detail}
        className="!m-0 !ml-0 list-none whitespace-pre-line !p-0 !pl-0 text-sm text-grey-700 [&_p:last-child]:mb-0 [&_p]:mb-2"
      />
    </article>
  );
};
